import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import Joyride from 'react-joyride';
import { stopJoyride } from '../../store/modules/options';

const mapActionCreators = {
  stopJoyride,
};

const mapStateToProps = state => ({
  runJoyride: state.options.runJoyride,
});

class JoyRideHeader extends React.Component {
  joyrideCallback = event => {
    if (event.action === 'close') {
      // this.props.stopJoyride();
    } else if (event.action === 'skip') {
      this.props.stopJoyride();
    }
  };

  render() {
    if (typeof this.props.runJoyride === 'undefined') {
      return null;
    }

    const joyrideSteps = [
      {
        title: 'Der Knotenpunkt: Aktivitäten',
        text:
          'Alles in SiMPL dreht sich um Aktivitäten. Sie sind eine Art Logbuch mit dem Sie alles festhalten können:<ul><li>Was wurde im letzten Meeting besprochen?</li><li>Was habe ich an diesem Tag gearbeitet?</li><li>Wie sieht der Vertrag in der finalen Version aus?</li></ul>',
        selector: '.joyRideHeaderActivity',
        position: 'top',
        type: 'hover',
        allowClicksThruHole: true,
        isFixed: true,
        style: {
          width: '29rem',
          beacon: {
            offsetY: 0,
          },
        },
      },
      {
        title: 'Ihre Benachrichtigungen',
        text:
          'Hier werden Sie über zugewiesene Aufgaben, Projektänderungen etc. informiert.',
        selector: '.joyRideHeaderNotifications',
        position: 'top',
        type: 'hover',
        allowClicksThruHole: true,
        isFixed: true,
        style: {
          width: '29rem',
          beacon: {
            offsetY: 0,
          },
        },
      },
      {
        title: 'Ihr Benutzermenü',
        text:
          'Hier finden Sie schnellen Zugriff zu allen Einstellungen. Außerdem können Sie hier dieses Tutorial deaktivieren.',
        selector: '.joyRideHeaderUser',
        position: 'top',
        type: 'hover',
        allowClicksThruHole: true,
        isFixed: true,
        style: {
          width: '29rem',
          beacon: {
            offsetY: 0,
          },
        },
      },
      {
        title: 'Die Seitenleiste',
        text:
          'Sollten Sie Ihre Aktivitäten und Aufgaben stets auf einen Blick sehen wollen, können Sie hier eine Seitenleiste einblenden.',
        selector: '.joyRideHeaderSidebar',
        position: 'top',
        type: 'hover',
        allowClicksThruHole: true,
        isFixed: true,
        style: {
          width: '29rem',
          beacon: {
            offsetY: 0,
          },
        },
      },
    ];

    return (
      <Joyride
        ref="joyride-header"
        steps={joyrideSteps}
        run={this.props.runJoyride} // or some other boolean for when you want to start it
        // debug={__DEV__}
        showSkipButton
        showStepsProgress
        type="continuous"
        callback={this.joyrideCallback}
        locale={{
          back: 'Zurück',
          close: 'Schließen',
          last: 'Schließen',
          next: 'Weiter',
          skip: 'Tutorial beenden',
        }}
      />
    );
  }
}
JoyRideHeader.propTypes = {
  runJoyride: PropTypes.bool.isRequired,
  stopJoyride: PropTypes.func.isRequired,
};
JoyRideHeader.defaultProps = {
  runJoyride: false,
};
export default connect(mapStateToProps, mapActionCreators)(JoyRideHeader);



// WEBPACK FOOTER //
// ./src/components/JoyRideHeader/JoyRideHeader.js